module.exports = __webpack_public_path__ + "static/media/1_13.e97c7635.png";